import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import "@zenlayer/zen-design/esm/svg-icon/style";
import _SvgIcon from "@zenlayer/zen-design/esm/svg-icon";
import { product_Alarm_str, product_API_str, product_BAG_str, product_BMC_str, product_CDN_str, product_CloudRouter_str, product_DCIntercom_str, product_EIP_str, product_GPU_str, product_L1_str, product_Loadbalance_str, product_MHS_str, product_P2P_str, product_Port_str, product_PrVI_str, product_PuVI_str, product_SDN_str, product_SecurityGroup_str, product_VIPFlow_str, product_VM_str, product_ZCS_str, product_ZGA_str } from '@zenlayer/zen-design-icons';
import { listUrlParamsStringify } from '@zenlayer/zen-design/esm/hooks/useRequest';
import t from '@zenlayer/zen-intl18';
import { stringify } from 'query-string';
import { unnest } from 'ramda';
import React from 'react';
import { getIsDefaultPartner } from "../data/consoleInfo"; // TODO 不用find使用filter筛选serversn ，serversn不是唯一值，服务级别加个唯一值

import { jsx as _jsx } from "react/jsx-runtime";

var getProductLink = function getProductLink(pathName, query, queryKey) {
  return "".concat(pathName).concat(query ? "?".concat(queryKey ? listUrlParamsStringify(query, undefined, queryKey) : stringify(query)) : '');
};

var ECategory;

(function (ECategory) {
  ECategory["AI"] = "AI";
  ECategory["Compute"] = "Compute";
  ECategory["CloudNetworking"] = "CloudNetworking";
  ECategory["ContentDelivery_Accelerator"] = "ContentDelivery_Accelerator";
  ECategory["Analytics_Security"] = "Analytics_Security";
})(ECategory || (ECategory = {}));

var getCategoryMap = function getCategoryMap() {
  return {
    AI: {
      text: t('xIWD1P4vXync')
    },
    Compute: {
      text: t('D1T5kF5xilGm')
    },
    CloudNetworking: {
      text: t('JbxEoE2qdTpD')
    },
    ContentDelivery_Accelerator: {
      text: t('QRwFBHEvCgfw')
    },
    Analytics_Security: {
      text: t('XcOprTb8p937')
    }
  };
};

export function getAnalyticsSecurityInfo() {
  var CategoryMap = getCategoryMap();
  return {
    category: ECategory['Analytics_Security'],
    text: CategoryMap['Analytics_Security'].text,
    services: [{
      serviceSn: 'analytics_23812699821457453',
      //TODO
      serviceName: 'analytics_23812699821457453',
      //TODO
      text: t('ffJs9mpB0S2T'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_Alarm_str
      }),
      link: '/alarm',
      products: [{
        productSn: 'AlarmViewportSpotlight',
        //TODO
        productName: 'AlarmViewportSpotlight',
        //TODO
        text: t('Hzt7vAO5WDxN'),
        description: '产品描述',
        alias: 'alarm_spotlight',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_Alarm_str
        }),
        createLink: function createLink(search) {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/alarm/spotlight".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zvp:spotlight:list',
        detailLink: function detailLink(id) {
          return undefined;
        },
        detailAuth: undefined
      }, {
        productSn: 'AlarmViewportInsights',
        //TODO
        productName: 'AlarmViewportInsights',
        //TODO
        text: t('JBSVZ19DTSbh'),
        description: '产品描述',
        alias: 'alarm_insights',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_Alarm_str
        }),
        createLink: function createLink(search) {
          return "/alarm/insights/create".concat(search ? "?".concat(stringify(search)) : '');
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/alarm/insights".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zvp:insights:list',
        detailLink: function detailLink(id) {
          return "/alarm/insights?".concat(listUrlParamsStringify({
            insightId: id
          }));
        },
        detailAuth: 'zvp:insights:list'
      }, {
        productSn: 'AlarmResourcesTrigger',
        //TODO
        productName: 'AlarmResourcesTrigger',
        //TODO
        text: t('o8eRiNdk5crA'),
        description: '产品描述',
        alias: 'alarm_trigger',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_Alarm_str
        }),
        createLink: function createLink(search) {
          return "/alarm/triggerCreate".concat(search ? "?".concat(stringify(search)) : '');
        },
        createAuth: 'alarm:saveTrigger',
        listLink: function listLink(query) {
          return "/alarm/trigger".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'alarm:TriggerList',
        detailLink: function detailLink(id) {
          return "/alarm/trigger?".concat(listUrlParamsStringify({
            triggerUid: id
          }));
        },
        detailAuth: 'alarm:TriggerList'
      }]
    }]
  };
}
export function getAllCategoriesInfo() {
  var CategoryMap = getCategoryMap();
  return [{
    category: ECategory['AI'],
    text: CategoryMap['AI'].text,
    services: [{
      serviceSn: 'AI_68a2c627e4b0dd8b4acb5e35',
      serviceName: 'AI',
      text: t('fZbFfZ1wj30F'),
      description: t('lYDn8Io5WU7j'),
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_API_str
      }),
      link: '/aigw',
      products: [{
        productSn: 'ai_gateway',
        productName: 'AI Gateway',
        text: t('q0WyqsnUZ7Tb'),
        description: t('ps1HJo7wOVRh'),
        alias: 'ai_gateway',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_API_str
        }),
        createLink: function createLink(query) {
          return getProductLink('/aigw/aigateway/create', query);
        },
        createAuth: 'aigw:aigateway:create',
        listLink: function listLink(query) {
          return getProductLink('/aigw/aigateway', query, 'query');
        },
        listAuth: 'aigw:aigateway:list',
        detailLink: function detailLink(id) {
          return getProductLink('/aigw/aigateway', {
            id: id
          }, 'query');
        },
        detailAuth: 'aigw:aigateway:list'
      }]
    }]
  }, {
    category: ECategory['Compute'],
    text: CategoryMap['Compute'].text,
    services: [{
      serviceSn: 'bmc_23812699821457453',
      serviceName: 'Bare Metal',
      text: t('nvG_7AwmQhlU'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_BMC_str
      }),
      link: '/bmc',
      products: [{
        productSn: 'server_23810894098088003',
        productName: 'Bare Metal Instance',
        text: t('kchcrit4xifj'),
        description: '产品描述',
        alias: 'bmc_instance',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_BMC_str
        }),
        createLink: function createLink(search) {
          return "/bmc/server/create".concat(search ? "?".concat(stringify(search)) : '');
        },
        createText: t('8mAstFmSiOhe'),
        createAuth: 'bmcServer:create',
        listLink: function listLink(query) {
          return "/bmc/server".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'bmcServer:list',
        detailLink: function detailLink(id) {
          return "/bmc/server?".concat(id).concat(listUrlParamsStringify({
            idList: id
          }));
        },
        detailAuth: 'bmcServer:list'
      }, {
        productSn: 'ms_64898048848826425',
        productName: 'Manage Server',
        text: t('7_IIKiY7zvJK'),
        description: '产品描述',
        alias: 'mhs',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_MHS_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/bmc/manageHostServer".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'bmcServer:mhsServerList',
        detailLink: function detailLink(id) {
          return undefined;
        },
        detailAuth: undefined
      }, {
        productSn: 'bbwg_62e89d2fe4b026180fbaca25',
        productName: 'Bandwidth Cluster',
        text: t('EFRtjpj3lh8f'),
        description: '产品描述',
        alias: 'bandwidth',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_VIPFlow_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        // listLink: (query?: any) =>
        //   `/bmc/bandwidth${query ? `?${listUrlParamsStringify(query)}` : ''}`,
        // listAuth: 'bmc:bandwidthGroup:list',
        listLink: function listLink(query) {
          return "/traffic/bandwidth-cluster/list".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'ipt:cluster:list',
        // detailLink: (id: string) =>
        //   `/bmc/bandwidth?${listUrlParamsStringify({ groupUid: id })}`,
        // detailAuth: 'bmc:bandwidthGroup:list',
        detailLink: function detailLink(id) {
          return "/traffic/bandwidth-cluster/list?".concat(listUrlParamsStringify({
            clusterId: id
          }));
        },
        detailAuth: 'ipt:cluster:list'
      }, {
        productSn: 'vlan_655c9621e4b02b8f2008bb3a',
        productName: 'VLAN',
        text: t('EVHEnwJ--Bft'),
        description: '产品描述',
        alias: 'PuVI',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_PuVI_str
        }),
        createLink: function createLink() {
          return "/bmc/internetVlan/create";
        },
        createAuth: 'publicVirtualInterface:create',
        listLink: function listLink(query) {
          return "/bmc/internetVlan".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'publicVirtualInterface:list',
        detailLink: function detailLink(id) {
          return "/bmc/internetVlan?".concat(listUrlParamsStringify({
            idList: id
          }));
        },
        detailAuth: 'publicVirtualInterface:list'
      }, {
        productSn: 'vlan_23812245708357656',
        productName: 'CIDR Block',
        text: t('vngBCzyAJ5cn'),
        description: '产品描述',
        alias: 'cidr',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_BMC_str
        }),
        createLink: function createLink() {
          return "/bmc/cidrBlock/create_IPv4";
        },
        createAuth: 'cidrBlock:createIpv4Block',
        listLink: function listLink(query) {
          return "/bmc/cidrBlock".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'cidrBlock:list',
        detailLink: function detailLink(id) {
          return "/bmc/cidrBlock?".concat(listUrlParamsStringify({
            idList: id
          }));
        },
        detailAuth: 'cidrBlock:list'
      }, {
        productSn: 'eip_23811877389746267',
        productName: 'Elastic IP',
        text: t('DBHvC_qeG-YL'),
        description: '产品描述',
        alias: 'eip',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_EIP_str
        }),
        createLink: function createLink() {
          return "/bmc/elasticip/create/ipv4";
        },
        createAuth: 'elasticIp:orderIp',
        listLink: function listLink(query) {
          return "/bmc/elasticip".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'elasticIp:getIpList',
        detailLink: function detailLink(id) {
          return "/bmc/elasticip?".concat(listUrlParamsStringify({
            idList: id
          }));
        },
        detailAuth: 'elasticIp:getIpList'
      }, {
        productSn: 'bag_106309532212265035',
        productName: 'BAG',
        text: t('XQNe7-mZgId9'),
        description: '产品描述',
        alias: 'bag',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_BAG_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        //TODO
        listLink: function listLink(query) {
          return "/vipFlow/bag".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'bag:list',
        detailLink: function detailLink(id) {
          return undefined;
        },
        detailAuth: undefined
      }, {
        productSn: 'vpc_655c966ae4b02b8f2008bb3b',
        productName: 'VPC',
        text: t('ZlVuSeCVeTxb'),
        description: '产品描述',
        alias: 'VPC',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_PrVI_str
        }),
        createLink: function createLink() {
          return "/bmc/vpc/create";
        },
        createAuth: 'vpc:createVpcAndSubnet',
        listLink: function listLink(query) {
          return "/bmc/vpc".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'vpc:queryVpcList',
        detailLink: function detailLink(id) {
          return "/bmc/vpc?".concat(listUrlParamsStringify({
            idList: id
          }));
        },
        detailAuth: 'vpc:queryVpcList'
      }, {
        productSn: 'subnet_655c96abe4b02b8f2008bb3c',
        productName: 'Subnet',
        text: t('ZJ2geP-39FCw'),
        description: '产品描述',
        alias: 'subnet',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_PrVI_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        //TODO 弹窗
        listLink: function listLink(query) {
          return "/bmc/subnet".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'pvl:listPrivateVlans',
        detailLink: function detailLink(id) {
          return "/bmc/subnet?".concat(listUrlParamsStringify({
            idList: id
          }));
        },
        detailAuth: 'pvl:listPrivateVlans'
      }, {
        productSn: 'acl_656943f8e4b0ef17fbf22c31',
        productName: 'Network ACL',
        text: t('pYNEERe3wqYi'),
        description: '产品描述',
        alias: 'acl',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_SecurityGroup_str
        }),
        createLink: function createLink() {
          return "/bmc/acl/create";
        },
        createAuth: 'acl:create',
        listLink: function listLink(query) {
          return "/bmc/acl".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'acl:list',
        detailLink: function detailLink(id) {
          return "/bmc/acl?".concat(listUrlParamsStringify({
            aclId: id
          }));
        },
        detailAuth: 'acl:list'
      }, {
        productSn: 'vpn_64b9e949e4b0fe8fdf965cb7',
        productName: 'vpn providers',
        text: t('tDgOUb18pKpf'),
        description: '产品描述',
        alias: 'bmc_package',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_BMC_str
        }),
        createLink: function createLink(search) {
          return "/solution/package/create".concat(search ? "?".concat(stringify(search)) : '');
        },
        createAuth: 'package:createOrder',
        listLink: function listLink(query) {
          return "/bmc/server".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'bmcServer:list',
        detailLink: function detailLink(id) {
          return "/bmc/server?".concat(listUrlParamsStringify({
            idList: id
          }));
        },
        detailAuth: 'bmcServer:list'
      }, {
        productSn: 'bmc_sshkey',
        productName: 'BMC SSH Key Pair',
        text: t('psPrKngKNxEe'),
        description: '产品描述',
        alias: 'bmc_sshkey',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_BMC_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/sshKeyPair/bmc".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: ['bmcServer:list', 'ccs:keypair:list'],
        detailLink: function detailLink(id) {
          return "/sshKeyPair/bmc?".concat(listUrlParamsStringify({
            keyId: id
          }));
        },
        detailAuth: ['bmcServer:list', 'ccs:keypair:list']
      }]
    }, {
      serviceSn: 'ZEC_65a4a974e4b099802af81b32',
      serviceName: 'Elastic Compute',
      text: t('TGAuR1jqGf2S'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_ZCS_str
      }),
      link: '/zec',
      products: [{
        productSn: 'zec_instance',
        productName: 'Elastic Compute',
        text: t('khgSUrMIzIfm'),
        description: t('Xq7AW4DsJeuM'),
        alias: 'zec_instance',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink(search) {
          return "/zec/vmCreate".concat(search ? "?".concat(stringify(search)) : '');
        },
        createText: t('GGs9wNetUKXX'),
        createAuth: 'zec:instance:createInstance',
        listLink: function listLink(query) {
          return "/zec/virtualMachine".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:instance:listInstances',
        detailLink: function detailLink(id) {
          return "/zec/virtualMachine?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'zec:instance:listInstances'
      }, {
        productSn: 'zec_instance',
        productName: 'ZEC Disk',
        text: t('iaejsT6WQ2Bv'),
        description: t('eLvAy7SUSQpG'),
        alias: 'zec_disk',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink(query) {
          return getProductLink("/zec/disk/create", query);
        },
        createAuth: 'zec:disk:createDisk',
        listLink: function listLink(query) {
          return getProductLink('/zec/disk/list', query, 'query');
        },
        listAuth: 'zec:disk:diskList',
        detailLink: function detailLink(id) {
          return getProductLink('/zec/disk/list', {
            uuid: id
          }, 'query');
        },
        detailAuth: 'zec:disk:diskList'
      }, {
        productSn: 'zec_instance',
        productName: 'ZEC Snapshot',
        text: t('wFZ3dI6LlWyj'),
        description: '产品描述',
        alias: 'zec_disk_snapshot',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink(query) {
          return undefined;
        },
        createAuth: 'zec:snapshot:create',
        listLink: function listLink(query) {
          return getProductLink('/zec/snapshot', query, 'query');
        },
        listAuth: 'zec:snapshot:list',
        detailLink: function detailLink(id) {
          return getProductLink('/zec/snapshot', {
            uuid: id
          }, 'query');
        },
        detailAuth: 'zec:snapshot:list'
      }, {
        productSn: 'zec_image',
        productName: 'ZEC Image',
        text: t('KgEnANGEewGi'),
        description: '产品描述',
        alias: 'zec_image',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink(query) {
          return undefined;
        },
        createAuth: 'zec:image:create',
        listLink: function listLink(query) {
          return getProductLink('/zec/image', query, 'query');
        },
        listAuth: 'zec:image:list',
        detailLink: function detailLink(id) {
          return getProductLink('/zec/image', {
            uuid: id
          }, 'query');
        },
        detailAuth: 'zec:image:list'
      }, {
        productSn: 'zec_eip',
        productName: 'ZEC Elastic IP',
        text: t('nlePmftQSARN'),
        description: t('vJNlI1QX1s6c'),
        alias: 'zec_eip',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return "/zec/elastic-ip/create";
        },
        createAuth: 'zec:elasticIp:create',
        listLink: function listLink(query) {
          return "/zec/elastic-ip/list".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:elasticIp:list',
        detailLink: function detailLink(id) {
          return "/zec/elastic-ip/list?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: 'zec:elasticIp:list'
      }, {
        productSn: 'zec_eip',
        productName: 'ZEC CIDR Block',
        text: t('xS0dNPGQmJK8'),
        description: t('V8Sdwab7qtJs'),
        alias: 'zec_cidrBlock',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return "/zec/cidrBlock/create";
        },
        createAuth: 'zec:cidr:create',
        listLink: function listLink(query) {
          return "/zec/cidrBlock".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:cidr:list',
        detailLink: function detailLink(id) {
          return "/zec/cidrBlock?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: 'zec:cidr:list'
      }, {
        productSn: 'zec_eip',
        productName: 'ZEC IPv6',
        text: t('AjFiAfRUQbee'),
        description: '产品描述',
        alias: 'zec_ipv6',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: '',
        listLink: function listLink(query) {
          return "/zec/elastic-ipv6".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:ipv6:listIpv6s',
        detailLink: function detailLink(id) {
          return "/zec/elastic-ipv6?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'zec:ipv6:listIpv6s'
      }, {
        productSn: 'zec_vpc',
        productName: 'ZEC VPC',
        text: t('rGJ7zx1Si5af'),
        description: '产品描述',
        alias: 'zec_vpc',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return "/zec/vpc/create";
        },
        createAuth: 'zec:vpc:create',
        listLink: function listLink(query) {
          return "/zec/vpc".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:vpc:list',
        detailLink: function detailLink(id) {
          return "/zec/vpc?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'zec:vpc:list'
      }, {
        productSn: 'zec_subnet',
        productName: 'ZEC Subnet',
        text: t('yVM45sjhuTOc'),
        description: '产品描述',
        alias: 'zec_subnet',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: 'zec:switch:create',
        listLink: function listLink(query) {
          return "/zec/subnet".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:switch:list',
        detailLink: function detailLink(id) {
          return "/zec/subnet?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'zec:switch:list'
      }, {
        productSn: 'zec_inter_region_bandwidth',
        productName: 'Cross-region Bandwidth',
        text: t('fToJ3dSHKVor'),
        description: t('EAlbO72vQqZ3'),
        alias: 'zec_inter_region_bandwidth',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return '/zec/bandwidth/create';
        },
        createAuth: 'zec:vpcBandwidth:create',
        listLink: function listLink(query) {
          return "/zec/bandwidth".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:vpcBandwidth:list',
        detailLink: function detailLink(id) {
          return "/zec/bandwidth?".concat(listUrlParamsStringify({
            bandwidthQuery: id
          }));
        },
        detailAuth: 'zec:vpcBandwidth:list'
      }, {
        productSn: 'zec_zbg',
        productName: 'ZEC ZBG',
        text: t('OEnLLMUz8oRM'),
        description: '产品描述',
        alias: 'zec_zbg',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return '/zec/borderGateway/create';
        },
        createAuth: 'zec:zbg:create',
        listLink: function listLink(query) {
          return "/zec/borderGateway".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:zbg:list',
        detailLink: function detailLink(zbgId) {
          return "/zec/borderGateway?".concat(listUrlParamsStringify({
            zbgId: zbgId
          }));
        },
        detailAuth: 'zec:zbg:list'
      }, {
        productSn: 'zec_vpc_route',
        productName: 'ZEC VPC Route',
        text: t('uAlqb9mupkFU'),
        description: '产品描述',
        alias: 'zec_route',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return '/zec/route/create';
        },
        createAuth: 'zec:route:create',
        listLink: function listLink(query) {
          return "/zec/route".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:route:list',
        detailLink: function detailLink(id) {
          return "/zec/route?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'zec:route:list'
      }, {
        productSn: 'zec_nat',
        productName: 'ZEC NAT Gateway',
        text: t('HLUFb7d6g882'),
        description: t('JJSNIOIuxuxq'),
        alias: 'zec_nat',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return '/zec/nat/create';
        },
        createAuth: 'zec:nat:create',
        listLink: function listLink(query) {
          return "/zec/nat".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:nat:list',
        detailLink: function detailLink(uuid) {
          return "/zec/nat?".concat(listUrlParamsStringify({
            uuid: uuid
          }));
        },
        detailAuth: 'zec:nat:list'
      }, {
        productSn: 'zec_nic',
        productName: 'ZEC NIC',
        text: t('Zja4EX61hY4n'),
        description: '产品描述',
        alias: 'zec_nic',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return '/zec/nic/create';
        },
        createAuth: 'zec:nic:create',
        listLink: function listLink(query) {
          return "/zec/nic".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:nic:list',
        detailLink: function detailLink(id) {
          return "/zec/nic?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'zec:nic:list'
      }, {
        productSn: 'zec_ddos',
        productName: 'DDoS Protection',
        text: t('yVLngdtzKPq4'),
        description: '产品描述',
        alias: 'zec_ddos',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/zec/ddos/overview".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:ddos:overview',
        detailLink: function detailLink(id) {
          return "/zec/ddos/overview?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'zec:ddos:overview'
      }, {
        productSn: 'zec_lb',
        productName: 'ZEC Load Balancing',
        text: t('s4uAKISYbEB8'),
        description: t('NCnvW3MEdH04'),
        alias: 'zec_lb',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_Loadbalance_str
        }),
        createLink: function createLink() {
          return '/zlb/load-balancer/create';
        },
        createAuth: 'zec:lb:create',
        listLink: function listLink(query) {
          return "/zlb/load-balancer".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:lb:list',
        detailLink: function detailLink(id) {
          return "/zlb/load-balancer?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: 'zec:lb:list'
      }, {
        productSn: 'zec_lb_listener',
        productName: 'ZEC LB Listener',
        text: t('gJ8vBXlzsZc9'),
        description: '产品描述',
        alias: 'zec_lb_listener',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_Loadbalance_str
        }),
        createLink: function createLink() {
          return '/zlb/load-balancer/listener/create';
        },
        createAuth: 'zec:lb:listener:create',
        listLink: function listLink(query) {
          return "/zlb/load-balancer/listener".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:lbListener:list',
        detailLink: function detailLink(id) {
          return "/zlb/load-balancer/listener?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: 'zec:lbListener:list'
      }, {
        productSn: 'zec_security_group',
        productName: 'ZEC Security Group',
        text: t('KgWOqxtbhEv5'),
        description: '产品描述',
        alias: 'zec_securityGroup',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return "/zec/securitygroup/create";
        },
        createAuth: 'zec:securityGroup:create',
        listLink: function listLink(query) {
          return "/zec/securitygroup".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:securityGroup:list',
        detailLink: function detailLink(id) {
          return "/zec/securitygroup?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'zec:securityGroup:list'
      }, {
        productSn: 'zec_sshkey',
        productName: 'ZEC SSH Key Pair',
        text: t('7Bf2BDZjIPgz'),
        description: '产品描述',
        alias: 'zec_sshkey',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZCS_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: 'ccs:keypair:import',
        listLink: function listLink(query) {
          return "/sshKeyPair/zec".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: ['zec:instance:listInstances', 'ccs:keypair:list'],
        detailLink: function detailLink(id) {
          return "/sshKeyPair/zec?".concat(listUrlParamsStringify({
            keyId: id
          }));
        },
        detailAuth: ['zec:instance:listInstances', 'ccs:keypair:list']
      }, {
        productSn: 'zec_instance',
        productName: 'GPU Cloud',
        text: t('3xrZELW9AGFY'),
        description: t('nPEuGyvhKVYT'),
        alias: 'gpu_instance',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_GPU_str
        }),
        createLink: function createLink(search) {
          return "/gpu/instance/create".concat(search ? "?".concat(stringify(search)) : '');
        },
        createAuth: 'zec:gpu:instance:createInstance',
        listLink: function listLink(query) {
          return "/gpu/instance".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'zec:gpu:instance:listInstances',
        detailLink: function detailLink(id) {
          return "/gpu/instance?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'zec:gpu:instance:listInstances'
      }]
    }, {
      serviceSn: 'zenvm',
      serviceName: 'Virtual Machine',
      text: t('LXOBv5fTxLQc'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_VM_str
      }),
      link: '/zenvm',
      products: [{
        productSn: 'prod_ensvm',
        productName: 'Virtual Machine',
        text: t('36hGwaEw6VpB'),
        description: '产品描述',
        alias: 'vm_instance',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_VM_str
        }),
        createLink: function createLink(search) {
          return "/zenvm/vmCreate".concat(search ? "?".concat(stringify(search)) : '');
        },
        createText: t('VMyxySPVGrQN'),
        createAuth: 'vm:instance:createInstance',
        listLink: function listLink(query) {
          return "/zenvm/virtualMachine".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'vm:instance:listEnsInstances',
        detailLink: function detailLink(id) {
          return "/zenvm/virtualMachine?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'vm:instance:listEnsInstances'
      }, {
        productSn: 'prod_ensvm',
        //'prod_disk',
        productName: 'Virtual Elastic Disk',
        text: t('B-J45sNb3xsp'),
        description: '产品描述',
        alias: 'vm_disk',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_VM_str
        }),
        createLink: function createLink() {
          return "/zenvm/diskCreate";
        },
        createAuth: 'vm:disk:createDisk',
        listLink: function listLink(query) {
          return "/zenvm/disk".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'vm:disk:diskList',
        detailLink: function detailLink(id) {
          return "/zenvm/disk?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: 'vm:disk:diskList'
      }, {
        productSn: 'prod_vmRegionBandwidth',
        productName: 'Bandwidth Cluster',
        text: t('gw5cQitIldSN'),
        description: '产品描述',
        alias: 'vm_bandwidthCluster',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_VM_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        // listLink: (query?: any) =>
        //   `/zenvm/zone95${query ? `?${listUrlParamsStringify(query)}` : ''}`,
        // listAuth: 'vm:bandwidthGroup:list',
        listLink: function listLink(query) {
          return "/traffic/bandwidth-cluster/list".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'ipt:cluster:list',
        // detailLink: (id: string) =>
        //   `/zenvm/zone95?${listUrlParamsStringify({
        //     bandwidthGroupUuid: id,
        //   })}`,
        // detailAuth: 'vm:bandwidthGroup:list',
        detailLink: function detailLink(id) {
          return "/traffic/bandwidth-cluster/list?".concat(listUrlParamsStringify({
            clusterId: id
          }));
        },
        detailAuth: 'ipt:cluster:list'
      }, {
        productSn: 'image_655c96dce4b02b8f2008bb3d',
        productName: 'Image',
        text: t('YrP4f9gFg1Qp'),
        description: '产品描述',
        alias: 'vm_image',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_VM_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/zenvm/images".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'vm:image:listImage',
        detailLink: function detailLink(id) {
          return "/zenvm/images?".concat(listUrlParamsStringify({
            bandwidthGroupUuid: id
          }));
        },
        detailAuth: 'vm:image:listImage'
      }, {
        productSn: 'cnet_655c9706e4b02b8f2008bb3e',
        productName: 'Classic Network',
        text: t('TDq2LylcTbwU'),
        description: '产品描述',
        alias: 'vm_classicNetwork',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_VM_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/zenvm/networking".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'vm:network:listEnsNetworks',
        detailLink: function detailLink(id) {
          return "/zenvm/networking?".concat(listUrlParamsStringify({
            bandwidthGroupUuid: id
          }));
        },
        detailAuth: 'vm:network:listEnsNetworks'
      }, {
        productSn: 'sec_g_6569445de4b0ef17fbf22c32',
        productName: 'Security Group',
        text: t('QTm3XDcasSsT'),
        description: '产品描述',
        alias: 'vm_securitygroup',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_VM_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/zenvm/securitygroup".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'vm:securityGroup:listEnsSecurityGroups',
        detailLink: function detailLink(id) {
          return "/zenvm/securitygroup?".concat(listUrlParamsStringify({
            id: id
          }));
        },
        detailAuth: 'vm:securityGroup:listEnsSecurityGroups'
      }, {
        productSn: 'sshkey_65694481e4b0ef17fbf22c33',
        productName: 'SSH Key Pair',
        text: t('eYJ8yiuvwByu'),
        description: '产品描述',
        alias: 'vm_sshkey',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_VM_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/sshKeyPair/zenvm".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: ['vm:instance:listEnsInstances', 'ccs:keypair:list'],
        detailLink: function detailLink(id) {
          return "/sshKeyPair/zenvm?".concat(listUrlParamsStringify({
            keyId: id
          }));
        },
        detailAuth: ['vm:instance:listEnsInstances', 'ccs:keypair:list']
      }]
    }, {
      serviceSn: 'IPT_65780e7be4b06b4032bd0096',
      serviceName: 'Traffic',
      text: t('NXaUFxLWM1cZ'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_VIPFlow_str
      }),
      link: '/traffic',
      products: [{
        productSn: 'cls_65780f29e4b06b4032bd0097',
        productName: 'Bandwidth Cluster',
        text: t('WPBKO7SNdBLB'),
        description: t('GK64dsaU7ItS'),
        alias: 'ipt_bandwidth',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_VIPFlow_str
        }),
        createLink: function createLink(query) {
          return getProductLink('/traffic/bandwidth-cluster/create', query);
        },
        createAuth: 'ipt:cluster:create',
        listLink: function listLink(query) {
          return getProductLink('/traffic/bandwidth-cluster/list', query, 'query');
        },
        listAuth: 'ipt:cluster:list',
        detailLink: function detailLink(id) {
          return getProductLink('/traffic/bandwidth-cluster/list', {
            clusterId: id
          }, 'query');
        },
        detailAuth: 'ipt:cluster:list'
      }, {
        productSn: 'ipt_pool',
        productName: 'Data Transfer Pool',
        text: t('half4je4qmb7'),
        description: t('Qqhg7GK9TiAg'),
        alias: 'ipt_pool',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_BMC_str
        }),
        createLink: function createLink(query) {
          return getProductLink('/traffic/transfer-packages/create', query);
        },
        createAuth: 'ipt:cluster:create',
        listLink: function listLink(query) {
          return getProductLink('/traffic/transfer-packages/list', query, 'query');
        },
        listAuth: 'ipt:traffic:list',
        detailLink: function detailLink(id) {
          return getProductLink('/traffic/transfer-packages/list', {
            clusterId: id
          }, 'query');
        },
        detailAuth: 'ipt:traffic:detail'
      }]
    }, {
      serviceSn: 'bmc_23812699821457453',
      serviceName: 'Bare Metal',
      text: t('mABJWL8FzpLi'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_BMC_str
      }),
      link: '/bgp',
      products: [{
        productSn: 'bgpasn_65d2b53ae4b02adb5ac7d11g',
        productName: 'BGP ASN',
        text: t('SdULmbZ4uXC3'),
        description: '产品描述',
        alias: 'bgp_asn',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_BMC_str
        }),
        createLink: function createLink(search) {
          return "/bgp/asn?openCreate=".concat(search ? stringify(search) : '1');
        },
        createAuth: 'bgp:asn:add',
        listLink: function listLink(query) {
          return "/bgp/asn".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'bgp:asn:list',
        detailLink: function detailLink(uid) {
          return "/bgp/asn?".concat(listUrlParamsStringify({
            uid: uid
          }));
        },
        detailAuth: 'bgp:asn:list'
      }, {
        productSn: 'bgp_65d2b53ae4b02adb5ac7d11e',
        productName: 'Global BGP',
        text: t('9dcPNnsdEDbK'),
        description: '产品描述',
        alias: 'bgp_session',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_BMC_str
        }),
        createLink: function createLink(search) {
          return "/bgp/session/create".concat(search ? "?".concat(stringify(search)) : '');
        },
        createAuth: 'bgp:create',
        listLink: function listLink(query) {
          return "/bgp/session".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'bgp:list',
        detailLink: function detailLink(uid) {
          return "/bgp/session?".concat(listUrlParamsStringify({
            uid: uid
          }));
        },
        detailAuth: 'bgp:list'
      }, {
        productSn: 'byoip_65d2b5e2e4b02adb5ac7d11f',
        productName: 'BYOIP',
        text: t('L3flTRBDeW0J'),
        description: '产品描述',
        alias: 'bgp_byoip',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_BMC_str
        }),
        createLink: function createLink(search) {
          return "/bgp/byoip?openCreate=".concat(search ? stringify(search) : '1');
        },
        createAuth: 'bgp:byoip:add',
        listLink: function listLink(query) {
          return "/bgp/byoip".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'bgp:byoip:list',
        detailLink: function detailLink(ip) {
          return "/bgp/byoip?".concat(listUrlParamsStringify({
            ip: ip
          }));
        },
        detailAuth: 'bgp:byoip:list'
      }]
    }]
  }, {
    category: ECategory['CloudNetworking'],
    text: CategoryMap['CloudNetworking'].text,
    services: [{
      serviceSn: 'Neu_632175c2e4b022622e135097',
      serviceName: 'Telin Networking',
      text: t('jbd09Z1BCisx'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_SDN_str
      }),
      link: getIsDefaultPartner() ? '/sdn/readl1' : '/sdn/l1',
      products: [getIsDefaultPartner() ? {
        productSn: 'wave_632175f9e4b022622e135098',
        productName: 'Neu-wave',
        text: t('J000wJni7Y2R'),
        description: '产品描述',
        alias: 'l1',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_L1_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/sdn/readl1".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'L1:console:wave:list:v1',
        detailLink: function detailLink(label) {
          return "/sdn/readl1?".concat(listUrlParamsStringify({
            label: label
          }));
        },
        detailAuth: 'L1:console:wave:list:v1'
      } : {
        productSn: 'wave_632175f9e4b022622e135098',
        productName: 'Neu-wave',
        text: t('XYlqQE2V_uxj'),
        description: '产品描述',
        alias: 'l1',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_L1_str
        }),
        createLink: function createLink() {
          return '/sdn/l1/create';
        },
        createAuth: ['menu_L1', 'waveself:op:create'],
        listLink: function listLink(query) {
          return "/sdn/l1".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: ['menu_L1', 'waveself:query:list'],
        detailLink: function detailLink(id) {
          return "/sdn/l1?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: ['menu_L1', 'waveself:query:list']
      }]
    }, {
      serviceSn: 'sdn_23812968227553307',
      serviceName: 'Cloud Networking',
      text: t('wK6BmwwGArZG'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_SDN_str
      }),
      link: '/sdn',
      products: [{
        productSn: 'covertprot_118622657099857921',
        productName: 'Private Cloud Backbone Port',
        text: t('1zaKL44-xRdL'),
        description: t('ZPtbkbE0qrHt'),
        alias: 'sdn_port',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_Port_str
        }),
        createLink: function createLink(search) {
          return "/sdn/port/create".concat(search ? "?".concat(stringify(search)) : '');
        },
        createText: t('z17vvL4XJRCt'),
        createAuth: 'sdnSelfPort:createSelfServicePort',
        listLink: function listLink(query) {
          return "/sdn/port".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'sdnSelfPort:page',
        detailLink: function detailLink(id) {
          return "/sdn/port?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: 'sdnSelfPort:getSelfServicePort'
      }, {
        productSn: 'vll_222614293986672700',
        productName: 'Connection',
        text: t('NKllJHGu8eJ7'),
        description: t('H6iZiIj2ctdr'),
        alias: 'P2P',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_P2P_str
        }),
        createLink: function createLink() {
          return '/sdn/network/create/ptp';
        },
        createText: t('dpBVSUhPx0A0'),
        createAuth: 'sdnSelfVll:createSelfServiceVll',
        listLink: function listLink(query) {
          return "/sdn/network".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'aggSearch:search',
        detailLink: function detailLink(id) {
          return "/sdn/network?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: 'aggSearch:search'
      }, {
        productSn: 'router_280898590157570092',
        productName: 'Router',
        text: t('R2e_tf7C3xXu'),
        description: t('By4QBopm4q8d'),
        alias: 'cloudRouter',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_CloudRouter_str
        }),
        createLink: function createLink() {
          return '/sdn/router/create';
        },
        createText: t('LICLkZ1jB8KZ'),
        createAuth: 'sdn:createRouter',
        listLink: function listLink(query) {
          return "/sdn/router".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'sdn:listRouter',
        detailLink: function detailLink(id) {
          return "/sdn/router?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: 'sdn:listRouter'
      }, {
        productSn: 'physical_BqrjRysLoN',
        productName: 'SDN Physical Line',
        text: t('NQsrDni8Jjzr'),
        description: t('7jKiYPvMjtt4'),
        alias: 'sdn_xc',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_Port_str
        }),
        createLink: function createLink(search) {
          return "/sdn/port/cross-connect/create".concat(search ? "?".concat(stringify(search)) : '');
        },
        createAuth: 'sdn:xc:create',
        listLink: function listLink(query) {
          return "/sdn/port/cross-connect".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'sdn:xc:list',
        detailLink: function detailLink(id) {
          return "/sdn/port/cross-connect?".concat(listUrlParamsStringify({
            uuid: id
          }));
        },
        detailAuth: 'sdn:xc:list'
      }, {
        productSn: 'sdn_ript',
        productName: 'Remote IP Transit',
        text: t('oIl3fXiEPzSe'),
        description: t('WnYAs2rPua3T'),
        alias: 'sdn_ript',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_DCIntercom_str
        }),
        createLink: function createLink() {
          return "/ript/page/create";
        },
        createAuth: 'ipt:ript:create',
        listLink: function listLink(query) {
          return "/ript/page".concat(query ? "?".concat(listUrlParamsStringify(query)) : '');
        },
        listAuth: 'ipt:ript:list',
        detailLink: function detailLink(id) {
          return "/ript/page?".concat(listUrlParamsStringify({
            riptId: id
          }));
        },
        detailAuth: 'ipt:ript:list'
      }]
    }]
  }, {
    category: ECategory['ContentDelivery_Accelerator'],
    text: CategoryMap['ContentDelivery_Accelerator'].text,
    services: [{
      serviceSn: 'gia_75528796362506337',
      serviceName: 'Global Accelerator',
      text: t('TaRU4mNOayzJ'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_ZGA_str
      }),
      link: '/gia',
      products: [{
        productSn: 'gia_189645717743075391',
        productName: 'Accelerator',
        text: t('QtJVy4Omsif6'),
        description: '产品描述',
        alias: 'gia_accelerator',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZGA_str
        }),
        createLink: function createLink() {
          return "/gia/project/create";
        },
        createText: t('G0FFnzDroNrH'),
        createAuth: 'zgaAccelerator:createAccelerator',
        listLink: function listLink(query) {
          return "/gia/project";
        },
        listAuth: 'zgaAccelerator:getAcceleratorList',
        detailLink: function detailLink(id) {
          return "/gia/project?idList=".concat(id);
        },
        detailAuth: 'zgaAccelerator:getAcceleratorList'
      }, {
        productSn: 'sslcer_656944c9e4b0ef17fbf22c34',
        productName: 'SSL Certificates',
        text: t('X5cz5A9LNDnN'),
        description: '产品描述',
        alias: 'gia_ssl',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_ZGA_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        listLink: function listLink(query) {
          return "/sslManagement/zgaList";
        },
        listAuth: 'zgaCertificate:getCertificateList',
        detailLink: function detailLink(id) {
          return undefined;
        },
        detailAuth: undefined
      }]
    }, {
      serviceSn: 'ecn_76962342742523965',
      serviceName: 'CDN',
      text: t('CbTXe1kEZEOq'),
      description: '服务描述',
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: product_CDN_str
      }),
      link: '/cdn',
      products: [{
        productSn: 'domain_655c9725e4b02b8f2008bb3f',
        productName: 'Domains',
        text: t('us_Jx7mM9lPo'),
        description: '产品描述',
        alias: 'cdn_domain',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_CDN_str
        }),
        createLink: function createLink() {
          return "/cdn/domains/create";
        },
        createText: t('TVQyq43Cvd6H'),
        createAuth: 'domain:addDomain',
        listLink: function listLink(query) {
          return "/cdn/domains".concat(query ? "?".concat(stringify(query)) : '');
        },
        listAuth: 'domain:getDomainBasicList',
        detailLink: function detailLink(id) {
          return undefined;
        },
        detailAuth: undefined
      }, {
        productSn: 'sslcer_656944ede4b0ef17fbf22c35',
        productName: 'SSL Certificates',
        text: t('X5cz5A9LNDnN'),
        description: '产品描述',
        alias: 'cdn_ssl',
        icon: /*#__PURE__*/_jsx(_SvgIcon, {
          svgStr: product_CDN_str
        }),
        createLink: function createLink() {
          return undefined;
        },
        createAuth: undefined,
        //TODO 弹窗
        listLink: function listLink(query) {
          return "/sslManagement/cdnList";
        },
        listAuth: 'cdnCertificate:getCertificateList',
        detailLink: function detailLink(id) {
          return undefined;
        },
        detailAuth: undefined
      }]
    }]
  }];
}
/**
 * @function
 * 获取所有服务信息
 * @return {ServiceInfo[]}
 */

export function getAllServiceInfo() {
  return unnest(getAllCategoriesInfo().map(function (category) {
    return category.services;
  }));
}
/**
 * 获取单独服务信息
 * @function
 * @param {string} props.serviceSn - 服务的serviceSn
 * @return {ProductInfo}
 */

export function getServiceInfo(serviceSn) {
  return getAllServiceInfo().find(function (service) {
    return service.serviceSn === serviceSn;
  });
}
export function findProductInfo() {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var filter = arguments.length > 1 ? arguments[1] : undefined;
  return products === null || products === void 0 ? void 0 : products.find(function (product) {
    if (filter.productSn === 'prod_ensvm' || filter.productSn === 'zec_instance' || filter.productSn === 'zec_eip') {
      //如果productSn === prod_ensvm ,要判断productName   （后端vm实例和云盘用相同的productSn，通过productName区分）
      return product.productSn === filter.productSn && product.productName === filter.productName;
    } else {
      return product.productSn === filter.productSn;
    }
  });
}
/**
 * 获取产品信息
 * @function
 */

export function getProductInfo(serviceSn, productSn, productName) {
  var _getAllServiceInfo$fi;

  var products = (_getAllServiceInfo$fi = getAllServiceInfo().find(function (service) {
    return service.serviceSn === serviceSn;
  })) === null || _getAllServiceInfo$fi === void 0 ? void 0 : _getAllServiceInfo$fi.products;
  return findProductInfo(products, {
    productSn: productSn,
    productName: productName
  }) || {};
}
/**
 * 根据产品别名获取产品信息
 * @function
 * @param {ProductAlias} alias - 产品别名
 */

export function getProductInfoForAlias(alias) {
  var _info = {};
  getAllServiceInfo().some(function (service) {
    return service.products.some(function (product) {
      if (product.alias === alias) {
        _info = _objectSpread(_objectSpread({}, product), {}, {
          serviceSn: service.serviceSn,
          serviceName: service.serviceName,
          serviceText: service.text,
          serviceIcon: service.icon
        });
        return true;
      }

      return false;
    });
  });
  return _info;
}
/**
 * 根据一组产品别名获取对应的产品信息
 * @function
 * @param {ProductAlias[]} aliases - 产品别名的数组
 */

export function getProductInfoForAliases(aliases) {
  var infos = {};
  getAllServiceInfo().forEach(function (service) {
    return service.products.forEach(function (product) {
      if (aliases.includes(product.alias)) {
        infos[product.alias] = _objectSpread(_objectSpread({}, product), {}, {
          serviceSn: service.serviceSn,
          serviceName: service.serviceName,
          serviceText: service.text,
          serviceIcon: service.icon
        });
      }
    });
  });
  return infos;
}